import React, { useEffect } from 'react';

/**
 * Componente che serve come endpoint per la generazione diretta del feed XML.
 * Quando viene acceduto, attiva la generazione XML tramite Netlify Functions e serve il risultato.
 */
const XmlGenerateEndpoint = () => {
  useEffect(() => {
    generateSaveAndServeXml();
  }, []);
  
  const generateSaveAndServeXml = async () => {
    try {
      // Set content type header if available
      if (document.contentType) {
        document.contentType = 'application/xml; charset=UTF-8';
      }
      
      // Set cache control headers
      const cacheControl = document.createElement('meta');
      cacheControl.httpEquiv = 'Cache-Control';
      cacheControl.content = 'no-cache, no-store, must-revalidate';
      document.head.appendChild(cacheControl);
      
      const pragma = document.createElement('meta');
      pragma.httpEquiv = 'Pragma';
      pragma.content = 'no-cache';
      document.head.appendChild(pragma);
      
      const expires = document.createElement('meta');
      expires.httpEquiv = 'Expires';
      expires.content = '0';
      document.head.appendChild(expires);
      
      // Generate timestamp for cache busting
      const timestamp = Date.now();
      
      // Call the Netlify Function to generate XML with force flag
      try {
        const response = await fetch(`/.netlify/functions/property-feed?t=${timestamp}&force=true`, {
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        });
        
        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        }
        
        // Get the XML content
        const xml = await response.text();

        // Salva il file XML tramite la funzione generate-xml-file
        try {
          const generateResponse = await fetch(`/.netlify/functions/generate-xml-file`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Cache-Control': 'no-cache, no-store, must-revalidate'
            },
            body: JSON.stringify({ xml })
          });
          
          if (!generateResponse.ok) {
            console.warn('Failed to save XML file:', await generateResponse.text());
          }
        } catch (saveError) {
          console.warn('Error saving XML file:', saveError);
        }
        
        // Output XML directly to page
        document.open('text/xml');
        document.write(xml);
        document.close();
        
        // Notify parent window if in iframe
        if (window.parent && window.parent !== window) {
          window.parent.postMessage({ type: 'xml-generated', success: true }, '*');
        }
      } catch (error) {
        console.error('Error generating XML:', error);
        
        // Mostra messaggio di errore
        document.open('text/xml');
        document.write(`<?xml version="1.0" encoding="UTF-8"?>\n<error>Si è verificato un errore durante la generazione dell'XML: ${error instanceof Error ? error.message : 'Errore sconosciuto'}</error>`);
        document.close();
        
        // Notify parent window if in iframe
        if (window.parent && window.parent !== window) {
          window.parent.postMessage({ type: 'xml-generated', success: false, error: error instanceof Error ? error.message : 'Errore sconosciuto' }, '*');
        }
      }
    } catch (error) {
      console.error('Error in generateSaveAndServeXml:', error);
      
      // Mostra messaggio di errore
      document.open('text/xml');
      document.write(`<?xml version="1.0" encoding="UTF-8"?>\n<error>Si è verificato un errore durante la generazione dell'XML: ${error instanceof Error ? error.message : 'Errore sconosciuto'}</error>`);
      document.close();
    }
  };
  
  // This component doesn't need to render anything
  return null;
};

export default XmlGenerateEndpoint;